import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDateWithoutTime } from 'components/global/utils';
import { SkuParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { SkuReport } from '@api/order-reporting/types-deliveries/DeliveriesReports';
import { SkuReportGridData } from '@pages/reporting-pages/deliveries-sku/types/SkuReportGridData';
import { convertToGridData } from '@pages/reporting-pages/deliveries-sku/store/convertors';
import { DateRange } from '@project-types/DateRange';



interface ReportingDeliveriesSkuState {
	gridData: SkuReportGridData[] | null,
	dateRange: DateRange | null,
};

const initialState: ReportingDeliveriesSkuState = {
	gridData: null,
	dateRange: null,
};



export const reportingDeliveriesSkuSlice = createSlice({
	name: 'reportingDeliveriesSku',
	initialState,
	reducers: {
		createGridData: (state, action: PayloadAction<SkuReport[] | undefined | null>) => {
			state.gridData = convertToGridData(action.payload);
		},
		setDateRange: (state, action: PayloadAction<DateRange>) => {
			state.dateRange = action.payload;
		},
		setSearchParameters: (state, action: PayloadAction<SkuParams>) => {
			let stateFrom = state.dateRange ? state.dateRange.from : null;
			let paramFrom = action.payload.dateFrom ? getDateWithoutTime(action.payload.dateFrom) : null;
			let stateTo = state.dateRange ? state.dateRange.to : null;
			let paramTo = action.payload.dateTo ? getDateWithoutTime(action.payload.dateTo) : null;
			if (stateFrom !== paramFrom || stateTo !== paramTo) {
				state.dateRange = paramFrom && paramTo ? { from: paramFrom, to: paramTo } : null;
			}
		},
		resetStore: (_) => initialState,
	},
});



export const {
	createGridData,
	setDateRange,
	setSearchParameters,
	resetStore } = reportingDeliveriesSkuSlice.actions;